// extracted by mini-css-extract-plugin
module.exports = {"headerTitle":"HeaderTitle_headerTitle__3Ab7s"};